module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.86da78cb.ttf";